<mat-tab-group (selectedTabChange)="onTabChange($event)" class="alarms-tab-group">
  @if (isView() === 'CLASSIC' || isView() === 'TABS') {
    <mat-tab label="Alarmas">
      <mat-card>
        <mat-card-content>
          @if (isLoading()) {
            <div class="loading-spinner">
              <mat-spinner diameter="40"></mat-spinner>
              <span>Cargando alarmas...</span>
            </div>
          }
          @if (error()) {
            <div class="error-message">
              {{ error() }}
            </div>
          }
          @if (!isLoading() && !error()) {
            <div>
              <!-- Barra de controles distribuida horizontalmente -->
              @if (monitorId()) {
                <div class="controls-top-bar">
                  <div class="mute-container">
                    <button mat-stroked-button color="primary" class="mute-btn" (click)="toggleMute()">
                      <mat-icon>{{
                        isMuted() ? "volume_off" : "campaign"
                      }}</mat-icon>
                      {{ isMuted() ? "Activar sonido" : "Silenciar" }}
                    </button>
                  </div>
                  <!-- <div *ngIf="isAdministrator && monitorId" class="monitorButton-container"> -->
                  @if (isAdministrator()) {
                    <div class="monitorButton-container">
                      <button mat-stroked-button color="accent" class="mode-toggle-btn" (click)="toggleMonitorMode()">
                        <mat-icon>
                          {{ isMonitorMode() ? "toggle_on" : "toggle_off" }}
                        </mat-icon>
                        {{ isMonitorMode() ? "Modo Histórico" : "Modo Monitor" }}
                      </button>
                    </div>
                  }
                  <div class="help-container">
                    <button mat-icon-button class="help-btn" (click)="showAlarmsHelp()" matTooltip="Ayuda">
                      <mat-icon>help_outline</mat-icon>
                    </button>
                  </div>
                </div>
              }
              @if (alarms().length > 0 && isMonitorMode()) {
                <div class="table-container">
                  @if (isMonitorMode() || isAdministrator()) {
                    <div class="controls-row"></div>
                  }
                  <table mat-table [dataSource]="paginatedAlarms" class="mat-elevation-z8">
                    <!-- Columna de HolderId -->
                    <ng-container matColumnDef="holder">
                      <th mat-header-cell *matHeaderCellDef class="help-header-holder">
                        Nombre
                      </th>
                      <td mat-cell *matCellDef="let alarm" class="help-cell-holder">
                        <div class="cell-content">
                          {{ alarm.gpsReport?.assetName || "Holder sin nombre" }}
                          @if (newAlarmIds.has(alarm.id)) {
                            <span class="new-badge">NUEVO</span>
                          }
                        </div>
                      </td>
                    </ng-container>
                    <!-- Columna de DeviceId -->
                    <ng-container matColumnDef="deviceId">
                      <th mat-header-cell *matHeaderCellDef class="help-header-deviceId">
                        Placa
                      </th>
                      <td mat-cell *matCellDef="let alarm" class="help-cell-deviceId">
                        {{ alarm.gpsReport?.assetId || "sin placa" }}
                      </td>
                    </ng-container>
                    <!-- Columna de EventId -->
                    <ng-container matColumnDef="event">
                      <th mat-header-cell *matHeaderCellDef class="help-header-event">
                        Evento
                      </th>
                      <td mat-cell *matCellDef="let alarm" class="help-cell-event">
                        {{ alarm.gpsReport?.eventName || "Evento sin nombre" }}
                      </td>
                    </ng-container>
                    <!-- Columna de riskEvaluation -->
                    @if (this.isRiskEvaluation()) {
                      <ng-container matColumnDef="riskEvaluation">
                        <th mat-header-cell *matHeaderCellDef class="help-header-event">
                          Evaluación de Riesgo
                        </th>
                        <td mat-cell *matCellDef="let alarm" class="help-cell-event">
                          <!-- {{ alarm.riskEvaluation|| "Sin Evaluacion" }} -->
                          <span class="new-riskEvaluation" [style.color]="alarm.color"
                    [class.blink-critical]="alarm.riskLabel === 'CRÍTICO'" [ngClass]="{
                            'no-eval':
                              (!alarm.riskLabel || alarm.riskLabel === '') &&
                              (alarm.riskEvaluation === 0 ||
                                alarm.riskEvaluation === '0' ||
                                alarm.riskEvaluation == null),
                          }">
                            {{ alarm.riskLabel || "Sin Evaluacion" }} :
                            {{ alarm.riskEvaluation || "0" }}
                          </span>
                        </td>
                      </ng-container>
                    }
                    <!-- Columna de Dirección -->
                    <ng-container matColumnDef="direccion">
                      <th mat-header-cell *matHeaderCellDef class="help-header-direccion">
                        Dirección
                      </th>
                      <td mat-cell *matCellDef="let alarm" class="help-cell-direccion">
                        {{ alarm.gpsReport?.location || "Dirección sin nombre" }}
                      </td>
                    </ng-container>
                    <!-- Columna de Fecha Reporte-->
                    <ng-container matColumnDef="timestamp">
                      <th mat-header-cell *matHeaderCellDef class="help-header-timestamp">
                        Fecha de Reporte
                      </th>
                      <td mat-cell *matCellDef="let alarm" class="help-cell-timestamp">
                        {{
                        alarm.gpsReport?.reportDate
                        ? (alarm.gpsReport.reportDate
                        | date: "dd/MM/yyyy HH:mm")
                        : "N/A"
                        }}
                      </td>
                    </ng-container>
                    <!-- Columna de Fecha Ingreso -->
                    <ng-container matColumnDef="timestamp2">
                      <th mat-header-cell *matHeaderCellDef class="help-header-timestamp">
                        Fecha de Ingreso
                      </th>
                      <td mat-cell *matCellDef="let alarm" class="help-cell-timestamp">
                        {{
                        alarm.gpsReport?.inputDate
                        ? (alarm.gpsReport.inputDate
                        | date: "dd/MM/yyyy HH:mm")
                        : "N/A"
                        }}
                      </td>
                    </ng-container>
                    <!-- Columna de Estado -->
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef class="help-header-status">
                        Atendiendo
                        <mat-icon class="tooltip-icon"
                          matTooltip="Esta columna muestra quién está revisando actualmente la alarma"
                          matTooltipPosition="above" aria-label="Información sobre columna Atendiendo">
                          info_outline
                        </mat-icon>
                      </th>
                      <td mat-cell *matCellDef="let alarm" class="help-cell-status">
                        @if (attendenAlarmIds.has(alarm.id)) {
                          <span class="attending-badge">
                            {{ alarm.reviewingByName }}...
                          </span>
                        }
                        @if (
                          !attendenAlarmIds.has(alarm.id) && alarm.reviewingByName
                          ) {
                          <span>
                            {{ alarm.reviewingByName }}
                          </span>
                        }
                      </td>
                    </ng-container>
                    <!-- Encabezado de la tabla -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="help-header-table"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClick(row)"
                    [class]="getRowClass(row)" [style]="getRowStyle(row)" class="help-header-tr"></tr>
                  </table>
                  <!-- Paginador -->
                  <mat-paginator [length]="totalElements" [pageSize]="pageSize" [pageIndex]="pageIndex"
                    [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" aria-label="Seleccionar página">
                  </mat-paginator>
                </div>
              }
              <!-- =======================================================
              BARRA DE FILTROS PARA HISTÓRICO
              ======================================================= -->
              @if (!isMonitorMode() && monitorId()) {
                <div class="filters-container">
                  <mat-form-field appearance="outline">
                    <mat-label>Rango rápido</mat-label>
                    <!-- <mat-select [(ngModel)]="filters.dateRangePreset" (selectionChange)="onDateRangePresetChange($event.value)"> -->
                    <mat-select [(ngModel)]="filters.dateRangePreset"
                      (selectionChange)="onDateRangePresetChange($event.value)">
                      <mat-option value="LAST_7_DAYS">Últimos 7 días</mat-option>
                      <mat-option value="LAST_MONTH">Último mes</mat-option>
                      <mat-option value="LAST_3_MONTHS">Últimos 3 meses</mat-option>
                      <mat-option value="">Ninguno</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div>
                    <mat-form-field appearance="outline" class="filter-fecha-desde">
                      <mat-label>Fecha desde</mat-label>
                      <input matInput [matDatepicker]="fromPicker" [(ngModel)]="filters.fechaDesde"
                        [disabled]="!isFiltreDate()" />
                      <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                      <mat-datepicker #fromPicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="filter-fecha-hasta">
                      <mat-label>Fecha hasta</mat-label>
                      <input matInput [matDatepicker]="toPicker" [(ngModel)]="filters.fechaHasta"
                        [disabled]="!isFiltreDate()" />
                      <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                      <mat-datepicker #toPicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <mat-form-field appearance="outline" class="filter-clasificado-por">
                    <mat-label>Clasifico</mat-label>
                    <input type="text" matInput [formControl]="userControl" [matAutocomplete]="autoUsersClasifico"
                      placeholder="Buscar usuario..." />
                    <mat-autocomplete #autoUsersClasifico="matAutocomplete"
                      (optionSelected)="onUserSelected($event.option.value)">
                      @for (user of filteredUsers$ | async; track user) {
                        <mat-option [value]="user">
                          {{ user.name }} {{ user.familyName }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                  <button mat-flat-button color="primary" class="filter-btn" (click)="applyFilters()">
                    <mat-icon>filter_alt</mat-icon>
                    Filtrar
                  </button>
                  <button mat-stroked-button color="warn" class="clear-filter-btn" (click)="resetFilters()">
                    <mat-icon>close</mat-icon>
                    Limpiar
                  </button>
                  <!-- <button
                  mat-icon-button
                  class="help-btn"
                  (click)="showAlarmsHelp()"
                  matTooltip="Ayuda"
                  >
                  <mat-icon>help_outline</mat-icon>
                </button> -->
                <button mat-flat-button color="accent" class="export-btn" (click)="exportCSV()">
                  <mat-icon>download</mat-icon>
                  Exportar CSV
                </button>
              </div>
            }
            @if (alarms().length > 0 && !isMonitorMode()) {
              <div class="tableHistorico-container">
                <!-- =======================================================
                TABLA DEL HISTÓRICO
                ======================================================= -->
                <table mat-table [dataSource]="paginatedAlarms" class="mat-elevation-z8">
                  <!-- Tus columnas actuales SIN CAMBIOS -->
                  <ng-container matColumnDef="holder" class="holderHelpler">
                    <th mat-header-cell *matHeaderCellDef>Nombre</th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-holder">
                      <div class="cell-content">
                        {{ alarm.gpsReport?.assetName || "Holder sin nombre" }}
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="deviceId">
                    <th mat-header-cell *matHeaderCellDef>Placa</th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-deviceId">
                      {{ alarm.gpsReport?.assetId || "sin placa" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="event">
                    <th mat-header-cell *matHeaderCellDef>Evento</th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-event">
                      {{ alarm.gpsReport?.eventName || "Evento sin nombre" }}
                    </td>
                  </ng-container>
                  @if (this.isRiskEvaluation()) {
                    <ng-container matColumnDef="riskEvaluation">
                      <th mat-header-cell *matHeaderCellDef>
                        Evaluación de Riesgo
                      </th>
                      <td mat-cell *matCellDef="let alarm" class="help-cell-event">
                  <span class="new-riskEvaluation-historico" [style.background]="alarm.color" [ngClass]="{
                            'no-eval':
                              (!alarm.riskLabel || alarm.riskLabel === '') &&
                              (alarm.riskEvaluation === 0 ||
                                alarm.riskEvaluation === '0' ||
                                alarm.riskEvaluation == null),
                          }">
                          {{ alarm.riskLabel || "Sin Evaluacion" }} :
                          {{ alarm.riskEvaluation || "0" }}
                        </span>
                      </td>
                    </ng-container>
                  }
                  <ng-container matColumnDef="direccion">
                    <th mat-header-cell *matHeaderCellDef>Dirección</th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-direccion">
                      {{ alarm.gpsReport?.location || "Dirección sin nombre" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="timestamp">
                    <th mat-header-cell *matHeaderCellDef>Fecha de Reporte</th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-timestamp">
                      {{
                      alarm.gpsReport?.reportDate
                      ? (alarm.gpsReport.reportDate
                      | date: "dd/MM/yyyy HH:mm")
                      : "N/A"
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="timestamp2">
                    <th mat-header-cell *matHeaderCellDef>Fecha de Ingreso</th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-timestamp">
                      {{
                      alarm.gpsReport?.inputDate
                      ? (alarm.gpsReport.inputDate
                      | date: "dd/MM/yyyy HH:mm")
                      : "N/A"
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="reviso">
                    <th mat-header-cell *matHeaderCellDef>Atendiendo</th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-reviso">
                      {{ alarm.reviewingByName || "" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="casifDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Fecha de Clasificación
                    </th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-reviso">
                      {{
                      alarm.classifiedAt
                      ? (alarm.classifiedAt | date: "dd/MM/yyyy HH:mm")
                      : ""
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="atendio">
                    <th mat-header-cell *matHeaderCellDef>Clasifico</th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-atendio">
                      {{ alarm.resolvedByName || "" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="comentario">
                    <th mat-header-cell *matHeaderCellDef>Comentarios</th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-comentarios">
                      {{ alarm.observations || "" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let alarm" class="help-cell-status">
                      {{ alarm.status || "" }}
                    </td>
                  </ng-container>
                  <!-- Encabezado -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsHistorico" class="help-header-table"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsHistorico" class="help-header-tr"></tr>
                </table>
                <!-- Paginador -->
                <mat-paginator [length]="totalElements" [pageSize]="pageSize" [pageIndex]="pageIndex"
                  [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)">
                </mat-paginator>
              </div>
            }
            @if (alarms().length === 0) {
              <div class="no-data">No hay alarmas para mostrar</div>
            }
          </div>
        }
      </mat-card-content>
    </mat-card>
  </mat-tab>
}
@if (isView() === 'MAP' || isView() === 'TABS') {
  <mat-tab label="Mapa de Alarmas" class="mapa-tab">
    <ng-template mat-tab-label>
      <mat-icon class="tab-icon">map</mat-icon>
      <span>Mapa de Alarmas</span>
    </ng-template>
    <div class="mapa-riesgo-wrapper">
      <div class="mapa-container">
        <app-mapa-riesgo #mapaAlarmas [lastPositions]="lastPositions()" [isRiskEvaluation]="false" [alarms]="alarms()"
        [filteredAssetIds]="filteredAssetIds" [monitorId]="monitorId()" [newAlarmIds]="newAlarmIds" class="mapa-component"></app-mapa-riesgo>
      </div>
      <div class="posiciones-container">
        <app-lastposicion-monitor [lastPositions]="lastPositions()" [alarmsByAssetId]="alarmsByAssetId"
          [isRiskEvaluation]="false" [clusteringEnabled]="mapaAlarmas.clusteringEnabled" [alarms]="mapScrollAlarms()"
          [totalAlarms]="totalElements" [isLoadingAlarms]="isLoadingMapAlarms()"
          (vehicleSelected)="onVehicleSelected($event)" (lastPositionsUpdated)="onLastPositionsUpdated($event)"
          (toggleClusteringEvent)="mapaAlarmas.toggleClustering()" (loadMoreAlarms)="onLoadMoreAlarms()"
          [monitorId]="monitorId()" [newAlarmIds]="newAlarmIds" [selectedAlarmId]="selectedAlarmId()"
          (filteredAssetIdsChange)="onFilteredAssetIdsChange($event)"
          [onRowClick]="onRowClick.bind(this)"
        ></app-lastposicion-monitor>
      </div>
    </div>
  </mat-tab>
}
@if (isRiskEvaluation()) {
  @if (isRiskEvaluation() === true) {
    <mat-tab label="Mapa de Riesgo" class="mapa-tab">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">map</mat-icon>
        <span>Mapa de Riesgo</span>
      </ng-template>
      <div class="mapa-riesgo-wrapper">
        <div class="mapa-container">
          <app-mapa-riesgo #mapaAlarmas [lastPositions]="lastPositions()" [isRiskEvaluation]="true" [alarms]="alarms()"
          [monitorId]="monitorId()" [newAlarmIds]="newAlarmIds" class="mapa-component"></app-mapa-riesgo>
        </div>
        <div class="posiciones-container">
          <app-lastposicion [lastPositions]="lastPositions()" [alarmsByAssetId]="alarmsByAssetId" [isRiskEvaluation]="true"
            [clusteringEnabled]="mapaAlarmas.clusteringEnabled" (toggleClusteringEvent)="mapaAlarmas.toggleClustering($event)"
          (vehicleSelected)="onVehicleSelected($event)"></app-lastposicion>
        </div>
      </div>
    </mat-tab>
  }
}

</mat-tab-group>
